/** YouTube & Matterport URL helpers for rental virtual tours */

export function getYouTubeID(url) {
  if (!url) return null;
  const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[1].length === 11 ? match[1] : null;
}

export function isMatterportUrl(url) {
  if (!url?.trim()) return false;
  try {
    const host = new URL(url.trim()).hostname.toLowerCase();
    return host === 'matterport.com' || host.endsWith('.matterport.com');
  } catch {
    return false;
  }
}

function parseMatterportModelId(url) {
  if (!url?.trim()) return null;
  try {
    const u = new URL(url.trim());
    const host = u.hostname.toLowerCase();
    if (host !== 'matterport.com' && !host.endsWith('.matterport.com')) return null;

    let modelId = u.searchParams.get('m');
    if (!modelId) {
      const match = u.pathname.match(/\/models\/([^/]+)/i);
      if (match) modelId = match[1];
    }
    return modelId || null;
  } catch {
    return null;
  }
}

export function getMatterportModelId(url) {
  return parseMatterportModelId(url);
}

/** Static preview image (no iframe) — similar to Matterport cover before play */
export function getMatterportThumbUrl(modelId) {
  if (!modelId) return null;
  return `https://my.matterport.com/api/v2/models/${encodeURIComponent(modelId)}/thumb?width=1280&height=720`;
}

/** iframe src after user clicks play; no play=1 so Matterport shows its own start screen */
export function getMatterportEmbedSrc(url) {
  const modelId = parseMatterportModelId(url);
  if (!modelId) return null;
  return `https://my.matterport.com/show/?m=${encodeURIComponent(modelId)}`;
}
